import { v4 as uuidv4 } from "uuid";
import { Question } from "@/types/question";

export default function cloneQuestion(question: Question): Question {
  return {
    ...question,
    id: uuidv4(),
  };
}
